// @spec VUL-STR-029
'use client';

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/vulnerabilities/settings')({
  // Keep backward compatibility for old links by redirecting to the unified settings page.
  beforeLoad: () => {
    // TanStack Router expects redirect to be thrown as control flow.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/settings/vulnerability-settings', replace: true });
  },
  component: () => null,
});
